import type { CustomerNames, FirstTimeSetupStatus } from '@studio/store/customer/types';
import type { Customer } from '@studio/types';
import { store } from '../../store';
import { customerAtom, customerFtsAtom, customerNamesAtom, isCustomerPollingAtom } from '../customer';

export const customerBridge = {
  customer: {
    failure: (error: Error): void => {
      store.set(customerAtom, (prev) => ({
        ...prev,
        error,
        hasFetched: true,
      }));
    },
    request: (): void => {
      store.set(customerAtom, (prev) => ({
        ...prev,
        error: null,
      }));
    },
    success: (data: Customer.Get.Customer): void => {
      store.set(customerAtom, {
        data,
        error: null,
        hasFetched: true,
        timestamp: Date.now(),
      });
    },
  },
  customerNames: {
    failure: (error: Error): void => {
      store.set(customerNamesAtom, (prev) => ({
        ...prev,
        error,
        hasFetched: true,
      }));
    },
    request: (): void => {
      store.set(customerNamesAtom, (prev) => ({
        ...prev,
        error: null,
      }));
    },
    success: (data: CustomerNames[]): void => {
      store.set(customerNamesAtom, {
        data,
        error: null,
        hasFetched: true,
        timestamp: Date.now(),
      });
    },
  },
  fts: {
    failure: (error: Error): void => {
      store.set(customerFtsAtom, (prev) => ({
        ...prev,
        error,
        hasFetched: true,
      }));
    },
    request: (): void => {
      store.set(customerFtsAtom, (prev) => ({
        ...prev,
        error: null,
      }));
    },
    success: (data: FirstTimeSetupStatus): void => {
      store.set(customerFtsAtom, {
        data,
        error: null,
        hasFetched: true,
        timestamp: Date.now(),
      });
    },
  },
  polling: {
    started: (): void => {
      store.set(isCustomerPollingAtom, true);
    },
    stopped: (): void => {
      store.set(isCustomerPollingAtom, false);
    },
  },
};
